export default __webpack_public_path__ + "static/fa-solid-900-1551f4f60c37af51121f106501f69b80.woff2";